import { RachelScope } from '../../rachel/effects/rachelScope';
import { RachelResource } from '../../rachel/effects/uiEffect.schema';

export const getOrderRachelScope = (orderId: string): RachelScope => ({
  resource: RachelResource.ORDER,
  scopeId: orderId,
});
